export const setSyncStatus = 'SYNCSTATUS_SET';
export const setViewSetting = 'VIEWSETTING_SET';

export const setProjectList = 'PROJECTLIST_SET';

export const addProject = 'PROJECT_ADD';
export const setProject = 'PROJECT_SET';
export const setProjectProperties = 'PROJECT_SET_PROPS';
export const addProjectUserItem = 'PROJECT_ADD_USERITEM';
export const addProjectUserItemByIndex = 'PROJECT_ADD_USERITEM_BY_INDEX';
export const updateProjectUserItemOccupation = 'UPDATE_PROJECT_USERITEM_OCCUPATION';
export const deleteProjectUserItem = 'DELETE_PROJECT_USERITEM';
export const updateProjectUserItem = 'PROJECT_UPDATE_USERITEM';

export const addCompany = 'COMPANY_ADD';
export const setCompanyProperties = 'COMPANY_SET_PROPS';
export const setCompanyList = 'COMPANY_LIST_SET';
export const deleteCompany = 'COMPANY_DELETE';

export const setLoggedInPerson = 'PERSON_LOGGED_IN';
export const addPerson = 'PERSON_ADD';
export const setPersonProperties = 'PERSON_SET_PROPS';
export const setPersonList = 'PERSON_LIST_SET';
export const deletePerson = 'PERSON_DELETE';

export const setStages = 'STAGES_SET';

export const selectStage = 'STAGE_SELECT';
export const addStage = 'STAGE_ADD';
export const addSyncedStage = 'STAGE_SYNC_ADD';
export const deleteStage = 'STAGE_DELETE';
export const setStageProperties = 'STAGE_SET_PROPS';

export const setParts = 'PARTS_SET';

export const selectPart = 'PART_SELECT';
export const addPart = 'PART_ADD';
export const addSyncedPart = 'PART_SYNCED_ADD';
export const deletePart = 'PART_DELETE';
export const setPartProperties = 'PART_SET_PROPS';

export const addPartComment = 'PART_COMMENT_ADD';
export const syncPartComment = 'PART_COMMENT_SYNC';
export const setLoggedInUserPartComments = 'LOGGED_IN_USER_SET_COMMENTS';
export const setSelectedPartComments = 'PART_SELECTED_SET_COMMENTS';

export const setIsBusy = 'IS_BUSY';
export const setLoggedIn = 'LOGGED_IN_SET';
export const setUser = 'USER_SET';

export const appendUndo = 'APPEND_UNDO';
export const clearUndo = 'UNDO_CLEAR';
export const undo = 'UNDO';
export const redo = 'REDO';

export const setKeyword = 'SET_KEYWORD';
export const keywordUpdate = 'KEYWORD_UPDATE';

export const addTodoItem = 'TODOITEM_ADD';
export const setTodoItemProperties = 'TODOITEM_SET_PROPERTIES';
export const deleteTodoItem = 'TODOITEM_DELETE';
export const setSelectedPartTodoItems = 'PART_SELECTED_SET_TODOITEMS';

export const setTodoTemplateProperties = 'TODOTEMPLATE_SET';
export const addTodoTemplate = 'TODOTEMPLATE_ADD';
export const setTodoTemplateList = 'TODOTEMPLATE_SETLIST';

export const addInspection = 'INSPECTION_ADD';
export const setInspectionProperties = 'INSPECTION_SET_PROPERTIES';
export const deleteInspection = 'INSPECTION_DELETE';
export const setSelectedPartInspection = 'PART_SELECTED_SET_INSPECTION';
export const addInspectionParticipant = 'INSPECTION_ADD_PARTICIPANT';

export const setInspectionTemplateProperties = 'INSPECTIONTEMPLATE_SET';
export const addInspectionTemplate = 'INSPECTIONTEMPLATE_ADD';
export const setInspectionTemplateList = 'INSPECTIONTEMPLATE_SETLIST';

export const setDiaryEntryProperties = 'DIARYENTRY_SET';
export const addDiaryEntry = 'DIARYENTRY_ADD';
export const setDiaryEntries = 'DIARYENTRY_SETLIST';
export const selectDiaryEntry = 'DIARYENTRY_SELECT';
export const diaryEntryAddItem = 'DIARYENTRY_ADDITEM';
export const diaryEntryRemoveItem = 'DIARYENTRY_REMOVEITEM';
export const diaryEntrySetItemProperties = 'DIARYENTRY_SETITEM';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js